import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/front-user/shared/models/user.model';
import { UserService } from 'src/app/front-user/shared/services/user.service';
import { first } from 'rxjs/operators';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { PasswordStrengthValidator } from 'src/app/front-user/shared/validator/password-strength.validators';
import { RegisterType } from 'src/app/shared/models/enums.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { EtenderService } from 'src/app/shared/services/etender.service';
import { ETenderAdminTypes } from 'src/app/shared/models/e-tender.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-offline-agent-registration',
  templateUrl: './offline-agent-registration.component.html',
  styleUrls: ['./offline-agent-registration.component.css']
})
export class OfflineAgentRegistrationComponent implements OnInit {
  user: User = new User();
  responseObject: ResponseObject = new ResponseObject;
  offlineRegistForm: FormGroup;
  loading = false;
  submitted = false;
  userGroups: number[] = [];
  IsRegistrationAdmin: boolean = false;
  constructor(
    private userService: UserService, private alertService: AlertService,
    private translate: TranslateService,
    private formBuilder: FormBuilder, private etenderSrv: EtenderService,
    private authenticationService: AuthenticationService,private router: Router, ) {
    this.user = this.authenticationService.currentUserValue;
    this.getUserGroups() ;
  }

  ngOnInit() {
    // this.buildForm();
  }
  getUserGroups() {
    this.etenderSrv.GetUserGroups(this.user.Email).subscribe(
      data => {
        this.userGroups = data.Data;
        if (this.userGroups != null) {
          if (this.userGroups.filter(ug => ug == ETenderAdminTypes.SCAServices_RegistrationAdmin).length > 0) {
            this.IsRegistrationAdmin = true;
          }
          if (!this.IsRegistrationAdmin) {
            this.router.navigate(['/unAuhtorized']);
          }
        }
      });
  }


}
